
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "Aniversariantes",
  props: {
    /**
     * Aceita:
     * - { data: [{ nome, data_nascimento, idade, telefone? }, ...] }
     * - OU diretamente um array: [{...}, {...}]
     */
    dados: {
      type: [Object, Array],
      default: () => ({ data: [] }),
    },
    // controle externo de loading
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      camposTabela: [
        { key: "nome_e_idade", label: "Nome" },
        { key: "idade", label: "Idade", class: "align-middle" },
        { key: "acoes", label: "", class: "text-right align-middle" },
      ],
    };
  },

  computed: {
    ...mapGetters(["currentUser", "empresa"]),
    items() {
      if (Array.isArray(this.dados)) return this.dados;
      if (this.dados && Array.isArray(this.dados.data)) return this.dados.data;
      return [];
    },
    companyToDisplay() {
      const empresa =
       this.currentUser?.nome ||
        {};
      return (
        empresa ||
        "nossa equipe"
      );
    },
    formattedToday() {
      return new Date().toLocaleDateString("pt-BR", {
        weekday: "short",
        day: "2-digit",
        month: "short",
      });
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return "-";
      return moment(date).isValid() ? moment(date).format("DD/MM/YYYY") : "-";
    },

    // Normaliza número para E.164 BR (adiciona 55 se faltar)
    toE164BR(fone) {
      if (!fone) return null;
      let digits = String(fone).replace(/\D+/g, "");
      digits = digits.replace(/^0+/, ""); // remove zeros à esquerda
      if (digits.startsWith("55")) return digits;
      if (digits.length >= 10 && digits.length <= 11) return `55${digits}`;
      return `55${digits}`; // fallback
    },

    getBirthdayMessage(aniversariante) {
      const nome = aniversariante?.nome || "cliente";

      return `${nome},
Hoje é um dia especial, e queremos aproveitar para lhe desejar um feliz aniversário!
Que esta nova fase traga muita felicidade, saúde e conquistas.
Que todos os seus objetivos sejam alcançados.
Feliz Aniversário!
Com carinho, ${this.companyToDisplay}.`;
    },

    openWhats(fone, mensagem = "") {
      const e164 = this.toE164BR(fone);
      if (!e164) {
        if (this.$bvToast) {
          this.$bvToast.toast("Número inválido para WhatsApp.", {
            variant: "danger",
            solid: true,
          });
        } else {
          alert("Número inválido para WhatsApp.");
        }
        return;
      }
      const text = encodeURIComponent(mensagem || "");
      const url = text
        ? `https://wa.me/${e164}?text=${text}`
        : `https://wa.me/${e164}`;
      window.open(url, "_blank");
    },
  },
};
